import { createApi } from '@reduxjs/toolkit/query/react';

import {
  ExpenseArticlesEndpoints as Endpoints,
  type GetExpenseArticlesRequest,
  type GetExpenseArticlesResponse,
  type UpdateExpenseArticleRequest,
  type UpdateExpenseArticleResponse,
} from '@app/api/ExpenseArticles/types';
import { createApiBaseQuery, Methods } from '@app/api/shared';
import { EXPENSE_ARTICLES } from '@app/constants';

export const expenseArticlesApi = createApi({
  reducerPath: 'expenseArticlesApi',
  baseQuery: createApiBaseQuery(EXPENSE_ARTICLES),
  endpoints: ({ query, mutation }) => ({
    [Endpoints.UpdateExpenseArticle]: mutation<
      UpdateExpenseArticleResponse,
      UpdateExpenseArticleRequest
    >({
      query: ({ data, ...params }) => ({
        url: Endpoints.UpdateExpenseArticle,
        method: Methods.POST,
        params,
        data,
      }),
    }),
    [Endpoints.GetExpenseArticles]: query<
      GetExpenseArticlesResponse,
      GetExpenseArticlesRequest
    >({
      query: (params) => ({
        url: Endpoints.GetExpenseArticles,
        method: Methods.GET,
        params,
      }),
    }),
  }),
});

export const {
  useUpdateExpenseArticleMutation,
  useGetExpenseArticlesQuery,
  useLazyGetExpenseArticlesQuery,
} = expenseArticlesApi;
